import { makeStyles } from '@material-ui/core/styles';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import Button from '@material-ui/core/Button';
import { useTranslation } from 'react-i18next';
import { useSnackbar } from 'notistack';
import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAddress } from '../Hooks/addressHook';
import { scrollToElementWhenReady } from '../Utils/scroll_utils';

const useStyles = makeStyles((theme) => ({
  notification: {
    '& > * + *': {
      marginTop: theme.spacing(2)
    },
    '& .MuiSnackbarContent-root': {
      backgroundColor: theme.palette.secondary.main,
      flexWrap: 'nowrap'
    },
    '& .MuiSnackbarContent-message': {
      color: theme.palette.text.primary,
      fontSize: '0.9rem',
      width: '100%',
      textAlign: 'center'
    },
    '& .MuiSnackbarContent-action': {}
  },
  notificationLink: {
    cursor: 'pointer',
    textDecoration: 'none',
    transition: 'filter 120ms ease-in-out',
    '&:hover': {
      filter: 'brightness(0.92)'
    },
    '&:focus-visible': {
      outline: `2px solid ${theme.palette.text.primary}`,
      outlineOffset: -3
    }
  }
}));

export function ShowNotificationBanner({ message, user = undefined, to = undefined }) {
  const classes = useStyles();
  let { t } = useTranslation();
  let { enqueueSnackbar } = useSnackbar();
  const address = useAddress();
  const cancelPendingScroll = useRef();

  const [show, setShow] = useState(true);
  console.log("[msg] ", show, user);

  const hideMessageForUser = (message, user) => {
    console.log("[msg] hide message!");
    setShow(false);

    // Create request
    const req = JSON.stringify({ message: message }); 

    // Send request
    fetch(address.api_url('/api/message/hide'), {
      method: 'POST', 
      body: req
    }).then((response) => {
      if (response.ok) {
        enqueueSnackbar(t("message_successfully_hiding_message"), { variant: 'info' });
      } else {
        enqueueSnackbar(t("message_failed_hideing_message"), { variant: 'error' });
      }
    });
  }

  useEffect(() => () => cancelPendingScroll.current?.(), []);

  const scrollToLinkedAnchor = () => {
    const hashIndex = typeof to === 'string' ? to.lastIndexOf('#') : -1;
    if (hashIndex === -1) return;

    cancelPendingScroll.current?.();
    cancelPendingScroll.current = scrollToElementWhenReady(
      decodeURIComponent(to.slice(hashIndex + 1)),
      { behavior: 'smooth', block: 'start' }
    );
  };

  if (!show) {
    return null;
  } 
  return (
    <div className={classes.notification}>
      <SnackbarContent
        {...(to
          ? {
              component: Link,
              to,
              onClick: scrollToLinkedAnchor,
              className: classes.notificationLink
            }
          : {})}
        message={message} 
        action={ user && (
          <Button onClick={() => hideMessageForUser(message, user)}>
            {t("dismiss")}
          </Button> 
        )}
      />
    </div>
  );
}
